import {AutoPlayButtonView} from '@fantasmagames/slot/src/modules/keypad/autoplay/AutoPlayButtonView';
export class RecodeAutoPlayButtonView extends AutoPlayButtonView {
	public init(): void {
		super.init();
		if (this.checkAutoplayDisabled()) {
			this.destroyAutoplayButton();
		}
	}

	protected checkAutoplayDisabled(): boolean {
		return !(window as any).V.API.Autoplay.getConfig().enabled;
	}

	protected destroyAutoplayButton(): void {
		this._autoplayButton.destroy();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/autoplay/recode/RecodeAutoPlayButtonView.ts